module.exports = __webpack_public_path__ + "static/media/fly0121.451556e7.webp";